import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import { IS_LOCAL } from 'modules/common/const';

import App from './App';

if (!IS_LOCAL) {
  Sentry.init({
    dsn: 'https://dcf1cfa39c34c7d5100e0c49946095e6@o286716.ingest.us.sentry.io/4509399884169216',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
    <StrictMode>
      <App />
    </StrictMode>
  </Sentry.ErrorBoundary>,
);
